import { PartialType } from '@nestjs/swagger';
import { CreateZonaCobranzaDto } from './create-zona-cobranza.dto';

export class UpdateZonaCobranzaDto extends PartialType(CreateZonaCobranzaDto) {}
